(function () {
    'use strict';

    angular.module('clientDashboardApp.httpUtil.getRequestService', [
        'clientDashboardApp.httpUtil.getRequestService'
    ]).service("getRequestService", GetRequestService);

    function GetRequestService() {
        this.requests = {};
    }

    GetRequestService.prototype.registerRequest = function (url, timestamp) {
        this.requests[url] = timestamp;
    };

    GetRequestService.prototype.isMostRecentRequest = function (url, timestamp) {
        if(timestamp !== this.requests[url]){
            console.log("most recent request timestamp: ",this.requests[url] || "undefined")
            console.log("current response's request timestamp: ",timestamp)
        }
        return timestamp == this.requests[url];
    }

})();
